import { render, staticRenderFns } from "./AcceptProductShare.vue?vue&type=template&id=9f640fa0"
import script from "./AcceptProductShare.vue?vue&type=script&lang=js"
export * from "./AcceptProductShare.vue?vue&type=script&lang=js"
import style0 from "./AcceptProductShare.vue?vue&type=style&index=0&id=9f640fa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports